<template>
    <div class="subjectTestpaperMarking padding-20 bgc box-shadow">
        <div class="markHeader">
            <span class="paperName"></span>
            <div>
                <el-select v-model="apidata.status" placeholder="考试状态" style="width: 150px">
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
                <!-- <el-input placeholder="参与时间段" v-model="dates" style="width: 200px"></el-input> -->
                 <el-date-picker
                    v-model="dates"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>

                <el-input placeholder="请输入参与人昵称" v-model="apidata.customername" style="width: 200px"></el-input>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </div>
        <div>
            <el-table :data="tableData">
                <el-table-column label="考试人" width="150" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img :src="scope.row.headimageurl ?scope.row.headimageurl :require('@/common/images/user.png')">
                            <div>{{ scope.row.customername }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="exampapername" label="试卷名称" class-name="center"></el-table-column>
                 <el-table-column label="考试状态" class-name="center">
                    <template slot-scope="scope">
                        <div class="imgStatus">
                            <span v-if="scope.row.status === 9" style="color: #FFA904">待批阅</span>
                            <span v-if="scope.row.status === 10" style="color: #67C23A">已完成</span>
                            <span v-if="scope.row.status === 1" style="color: #909399">未完成</span>
                            <!-- <span>未完成</span> -->
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="examtotalscore" label="最后得分" class-name="center"></el-table-column>
                <el-table-column prop="factexamtime" label="考试时长" class-name="center"></el-table-column>
                <el-table-column prop="begintime" label="开考时间" class-name="center"></el-table-column>


                <el-table-column label="操作" label-class-name="tr" width="120">
                    <template slot-scope="scope">
                       <div class="btnlist">
                            <el-button @click="goRouter('MarkingDetails', 0, scope.row.innerid)" :alt="scope" type="text" size="small">查看</el-button>
                            <el-button v-if="scope.row.status === 9" type="text" size="small">|</el-button>
                            <el-button v-if="scope.row.status === 9" @click="goRouter('MarkingDetails', 1, scope.row.innerid)" type="text" size="small">批阅</el-button>
                       </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </div>
    </div>
</template>
<script>
    import {getAllUserexamInfo} from 'api/questionApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    export default {
        name: "subjectTestpaperMarking",
        data() {
            return {
                tableData: [],
                total: 0,
                dates: [],   // 参与时间
                apidata: {
                    customername: '', //参与人名称
                    beginTime: '', //参与开始时间
                    endTime: '', //参与结束时间
                    status: '', // 状态
                    innerid: this.$route.query.qid,
                    page: 1,
                    pagesize: 10
                },
                statusList: [
                    {
                        label: '全部状态',
                        value: ''
                    },
                    {
                        label: '待批阅 ',
                        value: '9'
                    },
                    {
                        label: '已完成',
                        value: '10'
                    },
                    {
                        label: '未完成',
                        value: '100'
                    }
                ]
            }
        },
        mounted() {
            this.allList();
        },
        methods: {
            handleQuery() {
                if (this.dates && this.dates.length == 2) {
                    this.apidata.beginTime = this.dates[0]
                    // fecha.format(this.dates[0], 'yyyy-MM-dd HH:mm:ss')
                    this.apidata.endTime = this.dates[1]
                    // fecha.format(this.dates[1], 'yyyy-MM-dd HH:mm:ss')
                } else {
                    this.apidata.beginTime = ''
                    this.apidata.endTime = ''
                }
                this.allList()
                this.$refs.page.handleSizeChange(1)
                console.log(this.dates)
            },
            allList() {
                getAllUserexamInfo({
                    data: this.apidata,
                    success: data => {
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            goRouter(name, pageType, innerid) {   // 路由跳转
                this.$router.push({name: name, query: {id: innerid, pageType: pageType}})
            },
            searchClick() {},
            ...mapActions([
                'setLoading',
                'setPage'
            ])
        },
        components: {
            Loading,
            Page
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
    }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .subjectTestpaperMarking {
        .btnlist {
            text-align: right;
            .el-button {
                min-width: auto;
            }
            span {
                font-size: 12px;
            }
        }
        .el-tabs__header {
            margin: 0 0 0;
        }
        .markHeader {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 20px 0 20px 0;
            .paperName {
                font-size: 16px;
                color: #333;
            }
            .el-input__inner, .el-input, .el-select {
                margin-right: 20px;
                height: 36px;
            }
        }
        .imageText {
            display: flex;
            align-items: center;
            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-right: 12px;
            }
        }
        .center {
            text-align: center;
        }
    }
</style>
